import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& [data-amplify-container]': {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'stretch',

    '& .amplify-tabs': {

      '& .amplify-tabs-item': {
        '&[aria-selected="false"]': {
          backgroundColor: spaceCadet[100],
        },
      },
    },
    '& [data-amplify-router]': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      '& > div': {
        width: '100%',
        maxWidth: 768,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
      },
    },
  },
  '& form[data-amplify-authenticator-signin] fieldset > div:last-of-type': {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& label.amplify-label': {
      lineHeight: '18px',
    },
    '& .amplify-field-group.amplify-field-group--horizontal': {
      height: 18,
      '& .amplify-field-group__field-wrapper': {
        height: 18,
      },
    },
  },
  '& input.amplify-input[type="checkbox"]': {
    width: 16,
    minWidth: 16,
    position: 'relative',
    padding: 8,
    borderRadius: 4,
    '&:checked': {
      width: 16,
      minWidth: 16,
      boxShadow: 'none',
      backgroundColor: ultraMarine[500],
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main),
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 0,
      },
    },
  },
}));
export default StyledBox;
